import * as p from "react";
import { i as v, E as g, a as h, x as l, r as x, c as m } from "../createReactComponent-58f9bea8.mjs";
import { n as d } from "../property-9daa16cd.mjs";
import { e as w } from "../class-map-2994e95e.mjs";
import { r as f } from "../icon-button-a9d2a2d1.mjs";
import { g as u } from "../utils-cf5bbdd1.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
const b = v`
  :host {
    background: var(--exo-color-scrim);
    width: 100vw;
    overflow-x: hidden;
    overflow-y: auto;
  }

  :host .navigation-drawer {
    width: calc(5 * var(--exo-size-1));
    background: var(--exo-color-background);
  }

  :host .navigation-drawer__panel-header {
    display: flex;
    padding-top: var(--exo-spacing-large);
    padding-left: var(--exo-spacing-large);
    justify-content: space-between;
    align-items: baseline;
  }

  :host .navigation-drawer__panel-header ex-icon,
  ex-icon-button {
    display: inline-block;
    position: relative;
    right: var(--exo-spacing-large);
    top: var(--exo-spacing-2x-small);
    color: var(--exo-text-h2-color);
  }

  :host .navigation-drawer__panel-title {
    text-align: left;
    font: var(--exo-text-h3);
    color: var(--exo-text-h3-color);
  }

  @media only screen and (max-width: 544px) {
    :host .navigation-drawer {
      width: 100vw;
    }
  }
`;
var y = Object.defineProperty, C = Object.getOwnPropertyDescriptor, c = (a, t, r, i) => {
  for (var n, e = i > 1 ? void 0 : i ? C(t, r) : t, s = a.length - 1; s >= 0; s--)
    (n = a[s]) && (e = (i ? n(t, r, e) : n(e)) || e);
  return i && e && y(t, r, e), e;
};
class o extends g {
  constructor() {
    super(...arguments), this.panelTitle = "Main Header", this.hideClose = !1, this.navigationClosePanel = () => this.hideClose ? h : l`<ex-icon-button
          icon="cross"
          type="tertiary"
          circular
          @click=${this.closePanel}
          data-exo-locatorId-suffix=${u(this, "navigation-close-button")}
        ></ex-icon-button>`;
  }
  closePanel() {
    this.dispatchCustomEvent("onClose");
  }
  render() {
    return l`<div
      class=${w({ "navigation-drawer": !0 })}
      tabindex="-1"
    >
      <div class="navigation-drawer__panel-header">
        <h3 class="navigation-drawer__panel-title">
          <span>${this.panelTitle}</span>
        </h3>
        ${this.navigationClosePanel()}
      </div>
      <div>
        <slot></slot>
      </div>
    </div> `;
  }
}
o.styles = b, c([d()], o.prototype, "panelTitle", 2), c([d({ type: Boolean })], o.prototype, "hideClose", 2);
const _ = (a = "") => {
  x("ex-navigation-drawer", o, a), f(a);
}, z = m({ tagName: "ex-navigation-drawer", elementClass: o, react: p, events: { onClose: "onClose" }, displayName: "ExNavigationDrawer", registerWebComponent: _ });
export {
  z as ExNavigationDrawer,
  _ as register
};
